import { memo } from 'react';
import { FetchDataToIntegrationServerFromBackendForm } from './components/FetchDataToIntegrationServerFromBackendForm';
import { MinimalCard } from 'components/styled';

const FetchDataToIntegrationServerFromBackendCard = () => {
  return (
    <MinimalCard sx={{ height: '100%' }}>
      <FetchDataToIntegrationServerFromBackendForm />
    </MinimalCard>
  );
};

export default memo(FetchDataToIntegrationServerFromBackendCard);
